import { provideZoneChangeDetection } from '@angular/core';
// src/main.ts
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app.config';
import { AppComponent } from './app.component';

import { msalInstance, initMsal } from './app/pages/auth/msal.config';

import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { GlobalLoadingInterceptor } from './app/core/shared/global-loading.interceptor';

import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, LineElement, PointElement, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, LineElement, PointElement, ArcElement, Tooltip, Legend);

(async () => {
    try {
        // Initialize MSAL
        await initMsal();

        // Process any pending redirect (e.g., after interactive sign-in)
        await msalInstance.handleRedirectPromise();

        await bootstrapApplication(AppComponent, {
            ...appConfig,
            providers: [
                provideZoneChangeDetection(),
                ...(appConfig.providers || []),
                // provideHttpClient(withInterceptorsFromDi()),
                { provide: HTTP_INTERCEPTORS, useClass: GlobalLoadingInterceptor, multi: true }
            ]
        });
    } catch (err) {
        console.error('Bootstrap failed:', err);
    }
})();
